import { inject } from 'vue';

export const useProvidedContext = <T>(key: symbol | string): T => {
  const ctx = inject<T>(key);
  if (ctx === undefined) {
    throw new Error(`Context for ${key.toString()} was not provided`);
  }
  return ctx;
};
